import * as T from '../services/types'

/**
 * This is the accessed menu used for customer only
 */
export const ACCESSED_MENU: T.IAuthLoginResponse['accesses']['role_accesses'] = [
  {
    id: 10300,
    role_id: 17,
    menu_id: 142,
    create: false,
    read: true,
    update: false,
    delete: false,
    approve: false,
    export: true,
    print: true,
    attachment: false,
    menu: {
      id: 142,
      name: 'Dashboard',
      name_ind: 'Dasbor',
      uri: 'dashboard',
      sort: 1,
      parent_id: null,
      icon_id: 9,
      icon: {
        id: 9,
        icon_path: 'grid-1x2-fill.svg',
      },
      sub_menu: [],
    },
  },
  {
    id: 10301,
    role_id: 17,
    menu_id: 131,
    create: true,
    read: true,
    update: true,
    delete: true,
    approve: true,
    export: false,
    print: false,
    attachment: true,
    menu: {
      id: 131,
      name: 'Order Management',
      name_ind: 'Manajemen Pesanan',
      uri: 'management/order',
      sort: 2,
      parent_id: null,
      icon_id: 2,
      icon: {
        id: 2,
        icon_path: 'bar-chart-line-fill.svg',
      },
      sub_menu: [
        {
          id: 210,
          uri: 'management/order/amandement',
          name: 'Amendment',
          name_ind: 'Amandemen',
          parent_id: 131,
          create: false,
          read: true,
          update: false,
          delete: false,
          approve: false,
          export: false,
          print: false,
          attachment: false,
          icon: null,
        },
        {
          id: 211,
          uri: 'management/order/outstanding',
          name: 'Outstanding',
          name_ind: 'Outstanding',
          parent_id: 131,
          create: false,
          read: true,
          update: false,
          delete: false,
          approve: false,
          export: false,
          print: false,
          attachment: false,
          icon: null,
        },
        {
          id: 209,
          uri: 'management/order/reject',
          name: 'Reject',
          name_ind: 'Ditolak',
          parent_id: 131,
          create: false,
          read: true,
          update: false,
          delete: false,
          approve: false,
          export: false,
          print: false,
          attachment: false,
          icon: null,
        },
        {
          id: 218,
          uri: 'management/order/finish',
          name: 'Completed',
          name_ind: 'Selesai',
          parent_id: 131,
          create: false,
          read: true,
          update: false,
          delete: false,
          approve: false,
          export: false,
          print: false,
          attachment: false,
          icon: null,
        },
        {
          id: 212,
          uri: 'management/order/all',
          name: 'All Order',
          name_ind: 'Semua Pesanan',
          parent_id: 131,
          create: false,
          read: true,
          update: false,
          delete: false,
          approve: false,
          export: false,
          print: false,
          attachment: false,
          icon: null,
        },
      ],
    },
  },
  {
    id: 10304,
    role_id: 17,
    menu_id: 134,
    create: true,
    read: true,
    update: true,
    delete: true,
    approve: true,
    export: false,
    print: false,
    attachment: false,
    menu: {
      id: 134,
      name: 'Contract',
      name_ind: 'Kontrak',
      uri: 'management/kontrak',
      sort: 3,
      parent_id: null,
      icon_id: 9,
      icon: {
        id: 9,
        icon_path: 'grid-1x2-fill.svg',
      },
      sub_menu: [],
    },
  },
  {
    id: 10305,
    role_id: 17,
    menu_id: 138,
    create: true,
    read: true,
    update: true,
    delete: true,
    approve: true,
    export: false,
    print: false,
    attachment: false,
    menu: {
      id: 138,
      name: 'SO',
      name_ind: 'SO',
      uri: 'management/so',
      sort: 4,
      parent_id: null,
      icon_id: 13,
      icon: {
        id: 13,
        icon_path: 'person-lines-fill.svg',
      },
      sub_menu: [],
    },
  },
  {
    id: 10307,
    role_id: 17,
    menu_id: 206,
    create: true,
    read: true,
    update: true,
    delete: false,
    approve: false,
    export: false,
    print: false,
    attachment: false,
    menu: {
      id: 206,
      name: 'Invoice',
      name_ind: 'Invoice',
      uri: 'management/invoice',
      sort: 5,
      parent_id: null,
      icon_id: 3,
      icon: {
        id: 3,
        icon_path: 'body-text.svg',
      },
      sub_menu: [],
    },
  },
  {
    id: 10338,
    role_id: 17,
    menu_id: 168,
    create: false,
    read: true,
    update: false,
    delete: false,
    approve: false,
    export: false,
    print: false,
    attachment: false,
    menu: {
      id: 168,
      name: 'Negotiate',
      name_ind: 'Negosiasi',
      uri: 'negotiate',
      sort: 10,
      parent_id: null,
      icon_id: 10,
      icon: {
        id: 10,
        icon_path: 'handshake2.svg',
      },
      sub_menu: [],
    },
  },
  {
    id: 10343,
    role_id: 17,
    menu_id: 178,
    create: false,
    read: true,
    update: false,
    delete: false,
    approve: false,
    export: false,
    print: false,
    attachment: false,
    menu: {
      id: 178,
      name: 'Financial Document',
      name_ind: 'Dokumen Keuangan',
      uri: 'financial',
      sort: 20,
      parent_id: null,
      icon_id: 1,
      icon: {
        id: 1,
        icon_path: 'art002.svg',
      },
      sub_menu: [],
    },
  },
  {
    id: 10346,
    role_id: 17,
    menu_id: 191,
    create: false,
    read: true,
    update: false,
    delete: false,
    approve: false,
    export: false,
    print: false,
    attachment: false,
    menu: {
      id: 191,
      name: 'User Guide',
      name_ind: 'Panduan Pengguna',
      uri: 'user-guide',
      sort: 20,
      parent_id: null,
      icon_id: 4,
      icon: {
        id: 4,
        icon_path: 'book-half.svg',
      },
      sub_menu: [],
    },
  },
]
